import {Button, Modal} from "antd";
import {PackageURL} from "packageurl-js";
import React, {memo, useCallback, useState} from "react";
import {VisGraph, VisSingleContainer} from "@unovis/react";
import {Graph, GraphLayoutType, GraphNode} from "@unovis/ts";
import SelectedComponent from "./SelectedComponent";

interface UsageGraphModalProps {
    open: boolean;
    title: string;
    graphData: any;
    onClose: () => void;
}

const UsageGraphModal = memo(function ({open, title, graphData, onClose}: UsageGraphModalProps) {
    const [selectedNode, setSelectedNode] = useState<any>();
    const graphNodeLabel = useCallback(n => {
        try {
            const purl = PackageURL.fromString(n.label);

            return purl.name + " (" + purl.version + ")";
        } catch {
            return n.label;
        }
    }, []);
    const graphNodeSubLabel = useCallback(n => {
        try {
            const purl = PackageURL.fromString(n.label);

            return purl.namespace;
        } catch {
            return n.label;
        }
    }, []);
    const graphLinkStroke = useCallback(() => "#35D068", []);
    const closeModal = useCallback(() => {
        setSelectedNode(undefined);

        onClose();
    }, [onClose]);

    return <Modal open={open}
                  title={title}
                  onCancel={closeModal}
                  destroyOnHidden={true}
                  mask={{closable: false}}
                  width={1000}
                  footer={
                      <Button type={"primary"}
                              onClick={closeModal}>
                          Close
                      </Button>}
                  style={{top: 50}}
    >
        <SelectedComponent selectedNode={selectedNode}/>

        <VisSingleContainer data={graphData} style={{height: 'clamp(400px, 75vh, 1000px)'}}>
            <VisGraph
                layoutType={GraphLayoutType.Dagre}
                dagreLayoutSettings={{
                    rankdir: 'TB',
                    ranker: 'network-simplex',
                    ranksep: 50
                }}
                nodeLabelTrim={false}
                nodeSubLabelTrim={false}
                nodeLabel={graphNodeLabel}
                nodeSubLabel={graphNodeSubLabel}
                linkStroke={graphLinkStroke}
                selectedNodeId={selectedNode?.id}
                events={{
                    [Graph.selectors.node]: {
                        click: (d: GraphNode) => {
                            setSelectedNode(d);
                        }
                    },
                    [Graph.selectors.background]: {
                        click: () => {
                            setSelectedNode(undefined);
                        }
                    },
                }}
            />
        </VisSingleContainer>
    </Modal>;
});

export default UsageGraphModal;
